import React from 'react';
import styled from 'styled-components';
import NavLink from './NavLink';

const ActionLink = styled(NavLink)`
  &:not(:last-child) {
    margin-right: 14px;
  }
  @media (max-width: 960px) {
    flex-grow: 1;
    display: ${props => (props.hideOnMobile ? 'none' : 'inherit')};
  }
`;

const Actions = ({ items }) =>
  (items || []).map((item, idx) => (
    <ActionLink
      {...item}
      color="primary"
      variant={item.variant}
      size="medium"
      key={idx}
      hideOnMobile={item.hide_on_mobile}
    />
  ));

export default Actions;
